"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6790],{

/***/ 6836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90333);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34059);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88123);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1902);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34363);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const formatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const parser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter,
    parser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 38149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1902);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69433);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72852);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25989);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6836);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .Z.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 49800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 72852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 19782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ FreeShippingColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const FreeShippingColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10.2437 8.8V10.077H10.5287C10.6548 10.077 10.7384 10.0429 10.7939 9.98729C10.8495 9.93171 10.8837 9.84817 10.8837 9.722V9.155C10.8837 9.02883 10.8495 8.94529 10.7939 8.88971C10.7384 8.83413 10.6548 8.8 10.5287 8.8H10.2437Z",
          fill: "#30CD60"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 6C4.44772 6 4 6.44771 4 7V7.74985H0.625014C0.280006 7.74985 0 8.02986 0 8.37486C0 8.71987 0.280006 8.99988 0.625014 8.99988H4V10.2494H1.87453C1.52952 10.2494 1.24951 10.5294 1.24951 10.8744C1.24951 11.2194 1.52952 11.4994 1.87453 11.4994H4V12.75H3.12697C2.78196 12.75 2.50195 13.03 2.50195 13.375C2.50195 13.72 2.78196 14 3.12697 14H4V15C4 15.5523 4.44772 16 5 16L6.00197 16C6.05465 17.3322 7.15515 18.4 8.5 18.4C9.84482 18.4 10.9453 17.3322 10.998 16.0001L16.002 16.0002C16.0547 17.3323 17.1552 18.4 18.5 18.4C19.8448 18.4 20.9452 17.3323 20.998 16.0003L23.3751 16.0003C23.7201 16.0003 24.0002 15.7203 24.0002 15.3753V12.2502C24.0002 12.1365 23.9701 12.0252 23.9114 11.9289L22.0364 8.80388C21.9239 8.61512 21.7201 8.50012 21.5001 8.50012H20V7C20 6.44772 19.5523 6 19 6H5ZM22.6458 12.2499H20V9.74988H21.1458L22.6458 12.2499ZM7.5 15.9C7.5 15.35 7.948 14.9 8.5 14.9C9.052 14.9 9.5 15.35 9.5 15.9C9.5 16.45 9.052 16.9 8.5 16.9C7.948 16.9 7.5 16.45 7.5 15.9ZM18.5 14.9C17.948 14.9 17.5 15.35 17.5 15.9C17.5 16.45 17.948 16.9 18.5 16.9C19.052 16.9 19.5 16.45 19.5 15.9C19.5 15.35 19.052 14.9 18.5 14.9ZM6.30615 7.9H8.57815V8.8H7.24815V10.035H8.29815V10.935H7.24815V13H6.30615V7.9ZM9.30166 7.9H10.5637C10.9398 7.9 11.2496 8.01459 11.4818 8.25169C11.7138 8.48397 11.8257 8.79355 11.8257 9.169V9.708C11.8257 9.94543 11.7786 10.1598 11.6816 10.3487C11.5966 10.5142 11.4795 10.6493 11.3311 10.7527L11.9701 13H10.9908L10.4518 10.977H10.2437V13H9.30166V7.9ZM15.0007 7.9H12.6937V13H15.0007V12.1H13.6357V10.865H14.7207V9.965H13.6357V8.8H15.0007V7.9ZM15.7712 7.9H18.0782V8.8H16.7132V9.965H17.7982V10.865H16.7132V12.1H18.0782V13H15.7712V7.9Z",
          fill: "#30CD60"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 90333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 34567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92651);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {})));
};




/***/ }),

/***/ 96790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(98992);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(24122);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(38149);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(36344);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(13863);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(88384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(49800);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(88123);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-53f627c913/1/packages/ds-icon/dist/components/FreeShippingColored.es.js
var FreeShippingColored_es = __webpack_require__(19782);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/helpers/index.es.js
var helpers_index_es = __webpack_require__(71486);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js + 3 modules
var FlashSaleBar_index_es = __webpack_require__(86622);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(68481);
// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(53028);
// EXTERNAL MODULE: ../../packages/slug/dist/index.es.js
var dist_index_es = __webpack_require__(93512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/hooks/useQuantity.es.js
var useQuantity_es = __webpack_require__(18104);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(69168);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/FlashSaleBadge/FlashSaleBadge.es.js






const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzNkMzOC4yMDkxIDAgNDAgMS43OTA4NiA0MCA0VjM1LjgzODdDNDAgMzcuNTE1OCAzOC4wNjAxIDM4LjQ0ODEgMzYuNzUwNiAzNy40MDA1TDM2LjI0OTQgMzYuOTk5NUMzNS41MTkgMzYuNDE1MiAzNC40ODEgMzYuNDE1MiAzMy43NTA2IDM2Ljk5OTVMMzEuMjQ5NCAzOS4wMDA1QzMwLjUxOSAzOS41ODQ4IDI5LjQ4MSAzOS41ODQ4IDI4Ljc1MDYgMzkuMDAwNUwyNi4yNDk0IDM2Ljk5OTVDMjUuNTE5IDM2LjQxNTIgMjQuNDgxIDM2LjQxNTIgMjMuNzUwNiAzNi45OTk1TDIxLjI0OTQgMzkuMDAwNUMyMC41MTkgMzkuNTg0OCAxOS40ODEgMzkuNTg0OCAxOC43NTA2IDM5LjAwMDVMMTYuMjQ5NCAzNi45OTk1QzE1LjUxOSAzNi40MTUyIDE0LjQ4MSAzNi40MTUyIDEzLjc1MDYgMzYuOTk5NUwxMS4yNDk0IDM5LjAwMDVDMTAuNTE5IDM5LjU4NDggOS40ODEwNSAzOS41ODQ4IDguNzUwNjEgMzkuMDAwNUw2LjI0OTM5IDM2Ljk5OTVDNS41MTg5NSAzNi40MTUyIDQuNDgxMDUgMzYuNDE1MiAzLjc1MDYxIDM2Ljk5OTVMMy4yNDkzOSAzNy40MDA1QzEuOTM5ODYgMzguNDQ4MSAwIDM3LjUxNTggMCAzNS44Mzg3VjRaIgogICAgZmlsbD0iI0ZGREU2NyIgLz4KPC9zdmc+";
const SIZE = {
  s: {
    badge: 36,
    discountText: 8,
    percentText: 13
  },
  m: {
    badge: 40,
    discountText: 10,
    percentText: 15
  }
};
const FlashSaleBadge = ({
  discountPercent
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  return discountPercent ? /* @__PURE__ */ react.createElement(DiscountInfo, {
    size,
    background
  }, /* @__PURE__ */ react.createElement(DiscountText, {
    size
  }, (0,i18n_es.t)("GI\u1EA2M")), /* @__PURE__ */ react.createElement(PercentText, {
    size
  }, discountPercent, "%")) : null;
};
const DiscountText = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-weight: 700;
    color: #663009;
    line-height: 12px;
    font-size: ${SIZE[size].discountText}px;
`);
const PercentText = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-weight: 700;
    font-size: ${SIZE[size].percentText}px;
    line-height: 18px;
    color: #ee112e;
`);
const DiscountInfo = emotion_styled_browser_esm/* default.div */.Z.div(({ size, background: background2 }) => `
    width: ${SIZE[size].badge}px;
    height: ${SIZE[size].badge}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("${background2}");
    background-repeat: no-repeat;
    background-size: cover;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(57732);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/SavingBadge/SavingBadge.es.js






const SavingBadge_es_background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA5NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHJ4PSI0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiAvPgogIDxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjQwIj4KICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI0MCIgcng9IjQiIGZpbGw9IndoaXRlIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiCiAgICAgIGQ9Ik03NC4yNDQ2IC05LjAyODY5TDY1Ljg3NjcgOC45MTYyMUw3MC43NzA4IDExLjE5ODNMNjMuOTI0NCAyNS44ODA1TDg0LjQ3MjQgMTEuNjI5M0w3Ny45NDcgOC41ODY0Mkw5MC41NTgxIC0xLjQyMTU2TDc0LjI0NDYgLTkuMDI4NjlaIgogICAgICBmaWxsPSIjMUIxRDI5IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1LjcyMDkiIHkxPSIxLjY2NTQ0ZS0wNiIgeDI9IjU3Ljg4ODYiIHkyPSI0MC4wODczIgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBQTIwRkYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQxM0VGRiIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";
const SavingBadge_es_SIZE = {
  s: {
    titleFont: 8,
    discountFont: 12,
    discountLineHeight: 16
  },
  m: {
    titleFont: 10,
    discountFont: 13,
    discountLineHeight: 18
  }
};
const SavingBadge = ({
  savingAmount
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = isMobile ? "s" : "m";
  const formattedSavingAmount = (0,number_es/* formatCurrency */.x)(savingAmount);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background: SavingBadge_es_background
  }, /* @__PURE__ */ react.createElement(Title, {
    size
  }, (0,i18n_es.t)("TI\u1EBET KI\u1EC6M")), /* @__PURE__ */ react.createElement(DiscountAmount, {
    size
  }, formattedSavingAmount));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ background: background2, theme }) => `
  height: 36px;
  line-height: 12px;
  background: url("${background2}");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  background-size: cover;
`);
const Title = emotion_styled_browser_esm/* default.div */.Z.div(({ size }) => `
    font-size: ${SavingBadge_es_SIZE[size].titleFont}px;
    font-weight: 700;
    color: #ffd591;
`);
const DiscountAmount = emotion_styled_browser_esm/* default.div */.Z.div(({ size, theme }) => `
    font-size: ${SavingBadge_es_SIZE[size].discountFont}px;
    line-height: ${SavingBadge_es_SIZE[size].discountLineHeight}px;
    font-weight: 700;
    color: ${theme == null ? void 0 : theme.colors.white};
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(41425);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(34567);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/ProductCard/ProductCard.es.js
















var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCard_es_SIZE = {
  s: {
    padding: "s12"
  },
  m: {
    padding: "s16"
  }
};
const ProductCard = (_a) => {
  var _b = _a, {
    name,
    link,
    imageUrl,
    price,
    freeship,
    hasGift,
    gifts = {},
    infoTags,
    titleTag,
    ctaButton,
    contactButton,
    stockQuantityText,
    stockQuantity,
    flashSale,
    addToCart,
    textColor,
    brand,
    tracking,
    ctaTracking,
    needConfirmAge,
    type,
    renderUom,
    precisionToDisplayDecimalQuantity: precision
  } = _b, props = __objRest(_b, [
    "name",
    "link",
    "imageUrl",
    "price",
    "freeship",
    "hasGift",
    "gifts",
    "infoTags",
    "titleTag",
    "ctaButton",
    "contactButton",
    "stockQuantityText",
    "stockQuantity",
    "flashSale",
    "addToCart",
    "textColor",
    "brand",
    "tracking",
    "ctaTracking",
    "needConfirmAge",
    "type",
    "renderUom",
    "precisionToDisplayDecimalQuantity"
  ]);
  var _a2;
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const { showModal } = (0,hook_es/* useModal */.d)();
  const router = (0,next_router.useRouter)();
  const {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease
  } = (0,useQuantity_es/* useQuantity */.R)({
    addToCart,
    precision
  });
  const handleClickCtaButton = (e) => {
    var _a3;
    e.preventDefault();
    if (needConfirmAge) {
      showModal == null ? void 0 : showModal({
        title: isMobile ? (0,i18n_es.t)("C\u1EA3nh b\xE1o") : "",
        children: isMobile ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")) : /* @__PURE__ */ react.createElement(ModalConfirmWrap, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")),
        okText: (0,i18n_es.t)("T\xF4i tr\xEAn 18 tu\u1ED5i"),
        cancelText: (0,i18n_es.t)("T\xF4i d\u01B0\u1EDBi 18 tu\u1ED5i"),
        onOk: () => {
          (0,storage_es/* setCookieOver18YearOld */.zr)(true);
          addToCart == null ? void 0 : addToCart.onAddToCart();
        },
        width: isMobile ? "90%" : "400px",
        okButtonProps: { block: isMobile, size: "s" },
        cancelButtonProps: { block: isMobile, size: "s" },
        alignFooter: "center",
        showCloseIcon: isMobile
      });
    } else
      (_a3 = ctaButton == null ? void 0 : ctaButton.onClick) == null ? void 0 : _a3.call(ctaButton, e);
  };
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  const renderButton = () => {
    if (!addToCart)
      return null;
    const { quantityInCart } = addToCart;
    if (quantityInCart === 0) {
      if (ctaButton)
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, ctaButton), {
          onClick: (e) => {
            ctaButton.onClick && handleClickCtaButton(e);
          }
        }), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
      else
        return /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadValues({}, contactButton), ctaTracking), {
          size: "s",
          block: true,
          padding: "s0"
        }));
    }
    if ((quantityInCart != null ? quantityInCart : 0) > 0) {
      return /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, {
        block: true,
        quantity,
        setQuantity,
        onMinus: onDecrease,
        onPlus: onIncrease,
        min: 0,
        max: Math.min(stockQuantity, 999),
        color: "primary500",
        size: "s",
        onBlur: handleUpdateQuantity,
        onKeyPress: (e) => {
          if (e.key === "Enter")
            handleUpdateQuantity();
        },
        decimalSeparator: ".",
        precision
      });
    }
  };
  const productVisualWrapper = /* @__PURE__ */ react.createElement(ProductVisualWrapper, null, /* @__PURE__ */ react.createElement(ProductImageWrapper, null, /* @__PURE__ */ react.createElement(ProductImage, {
    hover: "zoom",
    height: "100%",
    objectFit: "contain",
    src: imageUrl,
    googleImageParams: {
      width: 230
    },
    alt: name
  })), ((_a2 = infoTags == null ? void 0 : infoTags.length) != null ? _a2 : 0) > 0 && /* @__PURE__ */ react.createElement(InfoTagsWrapper, null, infoTags == null ? void 0 : infoTags.map((tag, index) => /* @__PURE__ */ react.createElement(InfoTag, __spreadValues({
    key: index
  }, tag)))), flashSale && /* @__PURE__ */ react.createElement(react.Fragment, null, flashSale.discountPercent && /* @__PURE__ */ react.createElement(FlashSaleBadgeWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBadge, {
    discountPercent: flashSale.discountPercent
  })), /* @__PURE__ */ react.createElement(FlashSaleTimerWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBar_index_es/* FlashSaleBar */.P, __spreadValues({}, flashSale)))), (price == null ? void 0 : price.discountAmount) && /* @__PURE__ */ react.createElement(SavingBadgeWrapper, null, /* @__PURE__ */ react.createElement(SavingBadge, {
    savingAmount: price.discountAmount
  })));
  const productName = /* @__PURE__ */ react.createElement(react.Fragment, null, brand && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    line: 1,
    color: "textSecondary",
    hoverColor: "primary500",
    style: { textTransform: "uppercase", display: "inline" },
    onClick: (event) => {
      event.preventDefault();
      router.push({
        pathname: "/brands/[brandId]",
        query: {
          brandId: brand.code
        }
      }, `/${(0,dist_index_es/* default */.Z)(brand.name)}-brand.${brand.code}`);
    }
  }, brand.name)), /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ProductNameWrapper, null, /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    className: "att-product-card-title",
    level: 1,
    line: stockQuantityText ? 2 : 3,
    color: textColor || "textPrimary"
  }, titleTag && /* @__PURE__ */ react.createElement(TitleTag, __spreadValues({}, titleTag)), /* @__PURE__ */ react.createElement(StyledH3, {
    title: name
  }, name)), stockQuantityText && /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    color: textColor || "pending600"
  }, stockQuantityText)), !!renderUom && renderUom, /* @__PURE__ */ react.createElement(ProductSaleInfo, {
    freeship: !!freeship
  }, freeship && /* @__PURE__ */ react.createElement(StyledIconWrapper, null, /* @__PURE__ */ react.createElement(FreeShippingColored_es/* FreeShippingColored */.h, {
    size: 24
  })), /* @__PURE__ */ react.createElement(ProductPrice_es/* ProductPrice */.j, __spreadValues({}, price)))));
  const productGift = () => {
    var _a3;
    if (!hasGift || !((_a3 = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a3.length))
      return;
    const images = gifts.images.slice(0, 2);
    const more = gifts.images.length - 2;
    return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
      align: "center",
      gap: "s4"
    }, images.map((image, index) => /* @__PURE__ */ react.createElement(StyledGift, {
      width: 24,
      height: 24,
      key: index
    }, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      src: image.src,
      height: "100%",
      width: "100%",
      borderRadius: 4,
      alt: image.alt,
      contain: true
    }))), more > 0 && /* @__PURE__ */ react.createElement(MoreGift, {
      width: 24,
      height: 24
    }, "+", more));
  };
  const card = type === "list" ? /* @__PURE__ */ react.createElement("div", __spreadValues({
    style: { display: "flex", padding: "12px" },
    className: "product-card"
  }, tracking), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 3 }
  }, productVisualWrapper), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 7, marginLeft: "12px" }
  }, productName, productGift(), renderButton())) : /* @__PURE__ */ react.createElement(ProductCard_es_Wrapper, __spreadValues({
    size,
    className: "product-card"
  }, tracking), /* @__PURE__ */ react.createElement(ProductLink, __spreadValues(__spreadValues({}, link), props), /* @__PURE__ */ react.createElement(ProductCardContent, null, productVisualWrapper, productName, productGift())), renderButton());
  return card;
};
const ProductLink = (0,emotion_styled_browser_esm/* default */.Z)(CustomLink_es/* CustomLink */.x)`
  display: block;
`;
const ProductCard_es_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, size }) => `
    position: relative;
    width: 100%; 
    height: 100%;   
    padding: ${theme == null ? void 0 : theme.spacing[ProductCard_es_SIZE[size].padding]};
    display: flex;
    flex-direction: column;
    background-color: #fff;
    justify-content: space-between;
   `);
const StyledIconWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
`;
const ProductCardContent = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    position: relative;
    flex: 1 0 auto;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s8};
`);
const ProductVisualWrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    position: relative;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const ProductSaleInfo = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, freeship }) => `
    position: relative;
    margin-top: ${theme.spacing.s4};
    padding-right: ${freeship ? "1.5rem" : "unset"} ;
    margin-bottom: ${theme.spacing.s4}
`);
const Brand = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const TitleTag = (0,emotion_styled_browser_esm/* default */.Z)(Tag_es/* Tag */.V)(({ theme }) => `
  margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const InfoTag = (0,emotion_styled_browser_esm/* default */.Z)(Tag_es/* Tag */.V)(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
  `);
const InfoTagsWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
`;
const FlashSaleBadgeWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  top: 0;
  right: 0;
`;
const FlashSaleTimerWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
const SavingBadgeWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: absolute;
  bottom: 0;
  left: 0;
`;
const ProductImageWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  position: relative;
  padding-bottom: 100%;
`;
const ProductImage = (0,emotion_styled_browser_esm/* default */.Z)(EnhancedImage_es/* EnhancedImage */.N)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  object-fit: contain;
`;
const ProductNameWrapper = emotion_styled_browser_esm/* default.div */.Z.div`
  height: 3rem;
`;
const ModalConfirmWrap = emotion_styled_browser_esm/* default.h5 */.Z.h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
  text-align: center;
`;
const StyledH3 = emotion_styled_browser_esm/* default.h3 */.Z.h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;
const StyledGift = (0,emotion_styled_browser_esm/* default */.Z)(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50}; ;
`;
const MoreGift = (0,emotion_styled_browser_esm/* default */.Z)(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;




/***/ }),

/***/ 92651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97914);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25726);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1311);
/* harmony import */ var next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94665);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await resolveTekoPathname(getPathname(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await resolveTekoPathname(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as]);
  if (serverless) {
    return newState ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  return href ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href,
    as
  }, rest), {
    prefetch
  }), children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};
async function resolveTekoPathname(url) {
  var _a;
  const newHref = { pathname: "", query: {} };
  const pageList = (await (0,next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_3__.getClientBuildManifest)()).sortedPages;
  for (let i = 0; i < pageList.length; ++i) {
    const normalizedRoute = (_a = /\/(.*)\/(mobile|desktop)(.*)/.exec(pageList[i])) == null ? void 0 : _a[3];
    if (normalizedRoute) {
      const routeRegex = (0,next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_4__.getRouteRegex)(normalizedRoute);
      const matcher = (0,next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_5__.getRouteMatcher)(routeRegex)(url.pathname);
      if (matcher) {
        newHref.pathname = pageList[i];
        newHref.query = __spreadValues(__spreadValues(__spreadValues({}, matcher), getQuerystringObject(url.searchParams)), url.query);
        return newHref;
      }
    }
  }
  for (let i = 0; i < (customizedRoutes == null ? void 0 : customizedRoutes.length); ++i) {
    const { as, href } = customizedRoutes[i];
    const keys = [];
    const regex = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_6__/* .pathToRegexp */ .Bo)(as, keys);
    if (regex.test(url.pathname)) {
      const params = regex.exec(url.pathname);
      const combinedObject = Object.fromEntries(keys.map((k, i2) => [k.name, params == null ? void 0 : params[i2 + 1]]));
      const filteredObject = {};
      for (const k in combinedObject) {
        if (!/^[0-9]*$/g.test(k.toString())) {
          filteredObject[k] = combinedObject[k];
        }
      }
      const query = filteredObject;
      newHref.pathname = href;
      newHref.query = __spreadValues(__spreadValues(__spreadValues({}, query), getQuerystringObject(url.searchParams)), url.query);
      return newHref;
    }
  }
  return newHref;
}
function getQuerystringObject(qs) {
  const ret = {};
  if (!qs)
    return ret;
  for (const p of qs) {
    ret[p[0]] = p[1];
  }
  return ret;
}
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  color: black;
  text-decoration: none;
`;
function getPathname(href) {
  try {
    return new URL(href);
  } catch (e) {
    if (!href.startsWith("/")) {
      href = "/" + href;
    }
    return new URL(`https://fake.com${href}`);
  }
}
const contentSlugs = [
  "chinh-sach-bao-hanh",
  "huong-dan-xem-bao-cao-danh-cho-bo-cong-thuong",
  "chinh-sach-bao-mat",
  "chinh-sach-bao-mat-thanh-toan",
  "chinh-sach-bao-mat-thong-tin",
  "chinh-sach-bao-mat-thong-tin-ca-nhan",
  "chinh-sach-bao-mat-va-chia-se-thong-tin",
  "chinh-sach-bao-mat-va-su-dung",
  "chinh-sach-chiet-khau-uu-dai-mua-sam",
  "chinh-sach-doi-tra",
  "chinh-sach-doi-tra-va-hoan-tien",
  "chinh-sach-giai-quyet-khieu-nai",
  "chinh-sach-giao-hang",
  "chinh-sach-giao-nhan",
  "chinh-sach-kiem-hang",
  "chinh-sach-thanh-toan",
  "chinh-sach-thanh-vien",
  "chinh-sach-the-thanh-vien",
  "chinh-sach-uu-dai",
  "chinh-sach-van-chuyen",
  "chinh-sach-van-chuyen-va-giao-nhan",
  "co-che-dang-tai-thong-tin",
  "danh-sach-cua-hang",
  "dieu-khoan-su-dung",
  "dieu-khoan-va-dieu-kien-giao-dich",
  "gioi-thieu",
  "he-thong-thoi-vang-tich-luy",
  "hinh-thuc-giao-hang",
  "hinh-thuc-thanh-toan",
  "huong-dan-dang-ky-tai-khoan",
  "huong-dan-dat-hang",
  "huong-dan-dat-hang-tren-website",
  "huong-dan-dat-hang-va-dieu-khoan-hop-dong",
  "huong-dan-su-dung",
  "huong-dan-thanh-toan-vnpayqr",
  "quan-ly-chat-luong",
  "quy-che-cung-cap-dich-vu",
  "quy-dinh-va-hinh-thuc-thanh-toan",
  "thong-tin-lien-he",
  "thong-tin-san-pham",
  "thong-tin-ve-dieu-kien-giao-dich"
];
const customizedRoutes = [
  {
    as: "/landing/:id.html",
    href: "/landing/[id]"
  },
  {
    as: "/(.*)-cat.:catId([A-Za-z0-9._-]{1,20})",
    href: "/block-categories/[categoryId]"
  },
  {
    as: "/(.*)-scat.:sellerCategoryId([A-Za-z0-9._-]{1,20})",
    href: "/seller-categories/[sellerCategoryId]"
  },
  {
    as: "/(.*)-sel.:sellerId([A-Za-z0-9._-]{1,20})",
    href: "/sellers/[sellerId]"
  },
  {
    as: "/(.*)-brand.:brandId([A-Za-z0-9._-]{1,20})",
    href: "/brands/[brandId]"
  },
  {
    as: "/(.*)-s:sku([A-Za-z0-9._-]{1,20}).html",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--s:sku([A-Za-z0-9._-]{1,20})",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--p:productId([A-Za-z0-9._-]{1,20})",
    href: "/products/detail/[productId]"
  },
  {
    as: "/(.*)-:menuItemId.cat",
    href: "/categories/[menuItemId]"
  },
  {
    as: "/(.*)-c:menuItemId([0-9]{1,})",
    href: "/categories/[menuItemId]"
  },
  {
    as: `/:id(${contentSlugs.join("|")})`,
    href: "/content/[id]"
  }
];




/***/ }),

/***/ 18104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useQuantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31260);



const DELAY = 300;
const useQuantity = ({
  addToCart,
  baseQuantity = 0,
  precision = 0
}) => {
  const [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (addToCart && !loading) {
      setQuantity(addToCart.quantityInCart || baseQuantity);
    }
  }, [addToCart]);
  const updateQuantity = async (quantity2) => {
    var _a;
    setLoading(true);
    const normalizedQuantity = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .roundQuantity */ .pM)({
      quantity: quantity2,
      precision
    });
    if (normalizedQuantity === 0) {
      await ((_a = addToCart == null ? void 0 : addToCart.onRemoveItem) == null ? void 0 : _a.call(addToCart));
    } else {
      await (addToCart == null ? void 0 : addToCart.onChangeQuantity(normalizedQuantity));
    }
    setLoading(false);
  };
  const handleUpdateQuantity = async () => {
    if (quantity && quantity !== (addToCart == null ? void 0 : addToCart.quantityInCart)) {
      await updateQuantity(quantity);
    } else {
      setQuantity((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
    }
  };
  const debounceChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(async (q) => {
    await updateQuantity(q);
  }, DELAY), [addToCart]);
  const onIncrease = () => {
    setQuantity(quantity + 1);
    debounceChange(quantity + 1);
  };
  const onDecrease = () => {
    setQuantity(quantity - 1);
    debounceChange(quantity - 1);
  };
  return {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease
  };
};




/***/ })

}]);